import AuthService from '../index'
import AnalyticsService from "@emcd-shared/analytics-service";


function onRefreshError(error) {
  AnalyticsService.addBreadcrumb('AuthService.guard', 'onRefreshError')
  switch (error) {
    case 'Unauthorised':
      AnalyticsService.addBreadcrumb('AuthService.onRefreshError', {
        error,
        description: "Unauthorised, make logout",
      })
      AuthService.logout()
      break
    case 'axiosInstance error':
      AnalyticsService.addBreadcrumb('AuthService.onRefreshError', {
        error,
        description: "axiosInstance error, make logout",
      })
      AnalyticsService.error(`Initialization: ${error}`)
      AuthService.logout()
      break
    default:
      AnalyticsService.addBreadcrumb('AuthService.onRefreshError', {
        error,
        description: "UnException error, make logout",
      })
      AnalyticsService.error(`UnException: ${error}`)
      AuthService.logout()
  }
}

export function authGuard(axiosInstance, store) {
  return function (to, from, next) {
    AnalyticsService.addBreadcrumb('AuthService.authGuard',{
      description:`Redirect from ${from.fullPath}' to '${to.fullPath} and run authGuard check`,
    })

    AuthService.identify().then((res) => {
      AnalyticsService.addBreadcrumb('AuthService.authGuard',{
        description:`Success AuthService.identify, run auth/identify`,
      })
      store.dispatch('auth/identify', res)
    }).catch((e)=>{
      AnalyticsService.addBreadcrumb('AuthService.authGuard',{
        error: e,
        description: `auth/identify is failed`,
      })
    })
    AnalyticsService.addBreadcrumb('AuthService.authGuard',{
      description: "Check in redirected page are protected",
    })
    if (to?.matched?.some((record) => !!record?.meta?.requiresAuth)) {
      AnalyticsService.addBreadcrumb('AuthService.authGuard',{
        description: `Redirect to ${to.fullPath} page is protected run user authenticate`,
      })
      AuthService.authenticate()
        .then((res) => {
          store.dispatch('auth/authenticate', res)
          AnalyticsService.addBreadcrumb('AuthService.authGuard',{
            description: `Success auth/authenticate - user values saved to store, resolve redirect to protected page`,
          })
          next()
        })
        .catch((err) => {
          switch (err) {
            case 'Refresh':
              AnalyticsService.addBreadcrumb('AuthService.authGuard',{
                description: `Refresh, make AuthService.refresh`,
              });

              return AuthService.refresh(
                axiosInstance,
                (res) => store.dispatch('auth/authenticate', res)
              )
                .then(() => next())
                .catch((e) => AuthService.logout(e))
            case 'Unauthorised':
              AnalyticsService.addBreadcrumb('AuthService.authGuard',{
                description: `Unauthorised, make logout`,
              })
              AuthService.logout()
              break
            default:
              AnalyticsService.addBreadcrumb('AuthService.authGuard',{
                error: err,
                description: `UnException error, make logout`,
              })
              AnalyticsService.error(`UnException: ${err}`)
              AuthService.logout()
          }
        })
    } else {
      AnalyticsService.addBreadcrumb('AuthService.authGuard',{
        description: `Redirect page is not protected, resolve redirect to protected page`,
      })
      next()
    }
  }
}

export default authGuard
